<template>
  <div class="Home">
    <div class="header">
      <Menu />
    </div>
    <div class="content">
      <div class="container">
        <v-layout
          wrap
          justify-center
        ><img src="@/assets/images/logo-white.svg" class="logo">
        </v-layout>
        <v-layout
          wrap
          justify-center
        >
          <h1 class="title">RESEARCHMATTERS</h1>
        </v-layout>
        <v-layout
          wrap
          justify-center
        >
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/layout/menu/Menu.vue'
import { mapGetters } from 'vuex';

export default {
  components: { Menu },
  data: () => ({
    query: '',  // NOTE: Used if Home screen has a "How can I help?" text field
  }),
  computed: mapGetters({
    'username': 'auth/username'
  })
}
</script>

<style lang="scss" scoped>
.Home {
  color: #fff;
  background: linear-gradient(180deg, $dark-blue 15.1%, #188CB9 100%);
}

.header {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.content {
  min-height: calc(100vh - 50px);
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.logo {
  height: 50px;
  display: block;
  margin-bottom: 20px;
}

.home-search {
  margin-top: 24px;
}

.container {
  text-align: left;
  //margin-left: 50px;
}

.title {
  font-weight: 100;
}
</style>
